import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

import { Box } from "@/components/layout/flexbox";

const ellipsis = keyframes`
  to {
    width: 1.25em;
  }
`;

const MessageWithEllipsis = styled(Box)`
  &:after {
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    animation: ${ellipsis} steps(4, end) 900ms infinite;
    content: "…";
    width: 0px;
  }
`;

export default MessageWithEllipsis;
